import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './manage_cf.less'
import { Link as RouterLink, withRouter } from 'react-router'
import { glimpseRoute } from 'lib/route_utils'
import { exitGlimpse } from 'lib/glimpse'
import FlatProgress from 'components/common/flat_progress'
import NoCurrencyAlert from 'components/pages/campaign/no_currency_alert'
import { Icon, Row, Col, CaptionText, Link } from '@paypalcorp/pp-react'
import ToastContainer from 'components/common/toast_container'
import CampaignBalance from 'components/pages/campaign/campaign_balance'
import CrowdfundingActivity from 'components/glimpses/edit_glimpse/activity/crowdfunding_activity'
import CrowdfundingHeader from 'components/crowdfunding_campaign_header'
import { routerShape } from 'react-router/lib/PropTypes'
import { trackClick } from '../../../../lib/fpti_analytics'
import {
  INSTRUMENT_EVENTS,
  INSTRUMENT_TAGS,
  KEY_PRESS_EVENTS,
  TOAST_NOTIFICATIONS,
} from 'shared/shared_consts'

const { ENTER_KEY } = KEY_PRESS_EVENTS
const i18n = getI18n('components/edit_glimpse/manage_cf')

class Manage extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string,
    canDonateGNC: PropTypes.bool,
    canPledge: PropTypes.bool,
    charity: PropTypes.object,
    currencyCode: PropTypes.string,
    currentValue: PropTypes.number,
    dispatch: PropTypes.func,
    goal: PropTypes.number,
    hasChippedIn: PropTypes.bool,
    hasCurrencyBalance: PropTypes.bool,
    hasMoneybox: PropTypes.bool,
    onDonate: PropTypes.func,
    onTransfer: PropTypes.func,
    router: routerShape.isRequired,
    showUpdateSuccess: PropTypes.bool,
    paypalDomain: PropTypes.string,
  }

  handleTransferClick = event => {
    this.handleFPTI(event)
    if (!this.props.hasMoneybox) {
      event.preventDefault()
    } else {
      this.props.onTransfer()
    }
  }

  exitManage = event => {
    this.handleFPTI(event)
    exitGlimpse('edit', this.props.router)
  }

  handleDonateClick = event => {
    event.preventDefault()

    trackClick({
      clickName: INSTRUMENT_TAGS.DONATE,
      data: {
        event_name:
          INSTRUMENT_EVENTS.DW_GIVING_MANAGE_FUNDRASIER_DONATE_PRESSED,
        ...this.getFPTITags(),
      },
    })

    this.props.onDonate(this.props.campaignId)
  }

  handleFPTI = event => {
    if (event && event.currentTarget) {
      trackClick({
        clickName: event.currentTarget.getAttribute('ftpiTag'),
        data: {
          event_name: event.currentTarget.getAttribute('ftpiTag'),
          ...this.getFPTITags(),
        },
      })
    }
  }

  getFPTITags = () => {
    const { charity } = this.props
    return {
      flow:
        charity && charity.name
          ? 'GENEROSITY_NETWORK_CHARITIES'
          : 'GENEROSITY_NETWORK',
      charityname: charity && charity.name,
      crid: charity && charity.nonprofit_id,
    }
  }

  render() {
    const {
      campaignId,
      canDonateGNC,
      canPledge,
      charity,
      currencyCode,
      currentValue,
      goal,
      hasChippedIn,
      hasCurrencyBalance,
      hasMoneybox,
      paypalDomain,
    } = this.props
    const isCharity = !!charity && charity.name

    return (
      <div>
        {!hasCurrencyBalance && (
          <NoCurrencyAlert
            paypalDomain={paypalDomain}
            currency={currencyCode}
          />
        )}
        {this.props.showUpdateSuccess && (
          <ToastContainer
            delayTime={1000}
            message={i18n('update_success_message')}
            isSuccess={true}
            id={TOAST_NOTIFICATIONS.EDIT_SUCCESS}
          />
        )}
        <div styleName="text-center">
          <div styleName="pool-header">
            <CrowdfundingHeader
              campaignId={campaignId}
              showDaysRemaining={true}
            />
          </div>

          <FlatProgress
            goalAmount={goal}
            totalAmount={currentValue}
            currencyCode={currencyCode}
          />

          <Row styleName="manage-icon-row">
            {hasChippedIn &&
              !isCharity && (
                <Col xs={4} styleName="manage-icon-col">
                  <Link
                    as={RouterLink}
                    onClick={this.handleTransferClick}
                    ftpiTag="dw_giving_manage_fundraiser_transfer_pressed"
                    disabled={!hasMoneybox}
                    onKeyPress={e => {
                      if (e.key === ENTER_KEY) {
                        this.handleTransferClick()
                      }
                    }}
                    styleName="manage-link"
                    tabIndex={0}
                  >
                    <Icon
                      alt="transfer"
                      name="transfer-money"
                      size="lg"
                      styleName="manage-icons"
                    />
                  </Link>
                  <CaptionText styleName="manage-icon-text">
                    {i18n('transfer_link')}
                  </CaptionText>
                </Col>
              )}
            <Col xs={4} styleName="manage-icon-col">
              <Link
                aria-label="edit"
                as={RouterLink}
                styleName="manage-link"
                to={glimpseRoute('edit')}
                ftpiTag="dw_giving_manage_fundraiser_edit_pressed"
                data-nemo="editPool"
                onClick={this.handleFPTI}
              >
                <Icon
                  alt="edit"
                  name="edit"
                  size="lg"
                  styleName="manage-icons"
                />
              </Link>
              <CaptionText styleName="manage-icon-text">
                {i18n('edit_fundraiser')}
              </CaptionText>
            </Col>
            {canPledge &&
              !isCharity && (
                <Col xs={4} styleName="manage-icon-col">
                  <Link
                    aria-label="pledge"
                    as={RouterLink}
                    styleName="manage-link"
                    to={glimpseRoute('edit', 'pledge')}
                    ftpiTag="dw_giving_manage_fundraiser_pledge_bubble_pressed"
                    onClick={this.handleFPTI}
                  >
                    <Icon
                      alt="pledge"
                      name="donate"
                      size="lg"
                      styleName="manage-icons"
                    />
                  </Link>
                  <CaptionText styleName="manage-icon-text">
                    {i18n('pledge')}
                  </CaptionText>
                </Col>
              )}
            {canDonateGNC && (
              <Col xs={4} styleName="manage-icon-col">
                <Link
                  aria-label="donate"
                  as={RouterLink}
                  onClick={this.handleDonateClick}
                  styleName="manage-link"
                  to=""
                >
                  <Icon
                    alt="donate"
                    name="donate"
                    size="lg"
                    styleName="manage-icons"
                  />
                </Link>
                <CaptionText styleName="manage-icon-text">
                  {i18n('donate')}
                </CaptionText>
              </Col>
            )}
            <Col xs={4} styleName="manage-icon-col">
              <Link
                as={RouterLink}
                styleName="manage-link"
                ftpiTag="dw_giving_manage_fundraiser_show_pressed"
                onClick={this.exitManage}
                onKeyPress={e => {
                  if (e.key === ENTER_KEY) {
                    this.exitManage()
                  }
                }}
                tabIndex={0}
              >
                <Icon
                  alt="show fundraiser"
                  name="show-alt"
                  size="lg"
                  styleName="manage-icons"
                />
              </Link>
              <CaptionText styleName="manage-icon-text">
                {i18n('show_fundraiser')}
              </CaptionText>
            </Col>
            <Col xs={4} styleName="manage-icon-col">
              <Link
                aria-label="share"
                as={RouterLink}
                styleName="manage-link"
                to={glimpseRoute('edit', 'share')}
                ftpiTag="dw_giving_manage_fundraiser_share_bubble_pressed"
                onClick={this.handleFPTI}
              >
                <Icon
                  alt="share"
                  name="share"
                  size="lg"
                  styleName="manage-icons"
                />
              </Link>
              <CaptionText styleName="manage-icon-text">
                {i18n('share')}
              </CaptionText>
            </Col>
          </Row>
        </div>

        {!isCharity && <CampaignBalance campaignId={campaignId} />}

        {!isCharity && <CrowdfundingActivity campaignId={campaignId} />}
      </div>
    )
  }
}

export default withRouter(cssModules(Manage, styles))
